import React, { useState } from 'react';
import { Navbar, Nav, Offcanvas } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faVial } from '@fortawesome/free-solid-svg-icons';
import { useEnvironment } from "../contexts/EnvironmentContext.jsx";
import { AlignJustify, Bell } from 'lucide-react';
import knokoLogo from "@/assets/images/knokologo.png";
import home from "@/assets/images/home.svg";
import head from "@/assets/images/robothead.svg";
import gear from "@/assets/images/gear.svg";

const AppNavbar = () => {
    const {
        environment,
    } = useEnvironment();

    const { user, logout } = useAuth();
    const [showMenu, setShowMenu] = useState(false);

    return (
        <>
            <Navbar className="knoko-navbar" style={{ background: 'white', borderBottom: '1px solid #f0f0f0' }}>
                <div className="d-flex align-items-center justify-content-between w-100 px-3">
                    {/* Left: Hamburger */}
                    <button
                        className="knoko-hamburger"
                        onClick={() => setShowMenu(true)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}
                    >
                        <AlignJustify size={22} color="#298a99" />
                    </button>

                    {/* Center: Knoko logo */}
                    <a href="/dashboard" style={{ textDecoration: 'none' }}>
                        <img src={knokoLogo} alt="Knoko" style={{ height: '32px', width: 'auto' }} />
                    </a>

                    {/* Right: Bell icon */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        {environment === 'development' && (
                            <span style={{ fontSize: '10px', color: '#dc3545' }}>
                                <FontAwesomeIcon icon={faVial} className="me-1" />DEV
                            </span>
                        )}
                        <button
                            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}
                            onClick={() => {}}
                        >
                            <Bell size={22} color="#298a99" />
                        </button>
                    </div>
                </div>
            </Navbar>

            {/* Slide-out menu */}
            <Offcanvas show={showMenu} onHide={() => setShowMenu(false)} placement="start">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <img src={knokoLogo} alt="Knoko" style={{ height: '28px', width: 'auto' }} />
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Nav className="flex-column" style={{ gap: '8px' }}>
                        <Nav.Link href="/dashboard" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <img src={home} alt="home" style={{ maxWidth: '22px', height: 'auto' }} />
                            Home
                        </Nav.Link>
                        <Nav.Link href="/submissions" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <img src={head} alt="Memory" style={{ maxWidth: '22px', height: 'auto' }} />
                            Ian's Memory
                        </Nav.Link>
                        <Nav.Link href="/todos" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <FontAwesomeIcon icon={faList} /> To Do's
                        </Nav.Link>
                        <Nav.Link href="/settings" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <img src={gear} alt="Settings" style={{ maxWidth: '22px', height: 'auto' }} />
                            Settings
                        </Nav.Link>
                        {user && (
                            <>
                                <Nav.Link href="/profile">Profile</Nav.Link>
                                <Nav.Link href="#" onClick={() => logout()}>Logout</Nav.Link>
                            </>
                        )}
                    </Nav>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default AppNavbar;